import { render } from "./CertificateTakeRoomView.vue?vue&type=template&id=5c34b06f&scoped=true"
import script from "./CertificateTakeRoomView.vue?vue&type=script&lang=js"
export * from "./CertificateTakeRoomView.vue?vue&type=script&lang=js"

import "./CertificateTakeRoomView.vue?vue&type=style&index=0&id=5c34b06f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c34b06f"]])

export default __exports__